module.exports = __webpack_public_path__ + "img/image338.794ad967.png";